import axios from 'axios';
import envs from '@/envs';
import AlarmMsg from '@/utils/alarmMsg';
import tokenStore from './tokenStore';

const baseUrl = process.env.NODE_ENV === 'development' ? envs.devUrl : envs.buildUrl;

const refresher = async (refreshToken, accessToken) => {
  const response = await axios.post(`${baseUrl}/v2/getToken`, { token: refreshToken, token2: accessToken });

  if (response.data.code === 'ERR0004') {
    await AlarmMsg.showMsg({
      msg: '오랜시간 접속하여 로그인을 다시 진행하세요.',
      zIndex: 999999,
    });
    tokenStore.clear();
    window.location.href = '/';

    throw new Error('ERR0004');
  }

  if (response.data.code !== 'SUC0000') {
    throw new Error('Error refresh token');
  }

  return response.data.result.accessToken;
};

export default refresher;
